import '../auth.scss';

import { requestPasswordReset as requestPasswordResetAction } from '@basqet-dashboard/common/api';
import { ReactComponent as Logo } from '@basqet-dashboard/common/assets/logo.svg';
import { Button, FormInput } from '@basqet-dashboard/common/components';
import { useDocumentTitle } from '@basqet-dashboard/common/hooks';
import { forgotPasswordSchema } from '@basqet-dashboard/common/utils';
import { yupResolver } from '@hookform/resolvers/yup';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

function ForgotPassword() {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors }
  } = useForm({ mode: 'onChange', resolver: yupResolver(forgotPasswordSchema) });
  useDocumentTitle('Forgot password');

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (body) => {
    setIsLoading(true);
    try {
      await requestPasswordResetAction(body);
      toast.success(`If you have an account, you'll receive a password reset link`);
      setIsLoading(false);
    } catch (error) {
      if (error.response) {
        const {
          data: { message, data }
        } = error.response;
        toast.error(message);
        if (data && data.email) {
          setError('email', {
            type: 'manual',
            ...data.email
          });
        }
        setIsLoading(false);
      }
    }
  };

  return (
    <main className="auth">
      <div className="auth__content">
        <h1 className="page__title">
          Forgot <span className="text-cursive">password</span>
        </h1>
        <div className="auth__card">
          <Logo />
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="auth__card__input-area">
              <FormInput
                label="Email"
                role="menu"
                placeholder="Enter your email"
                name="email"
                type="email"
                error={errors.email && errors.email.message}
                register={register('email')}
              />
            </div>
            <Button isFull type="submit" isLoading={isLoading}>
              Request password reset email
            </Button>
          </form>
          <p className="auth__link">
            Go back to <Link to="/login">Login</Link>
          </p>
        </div>
      </div>
    </main>
  );
}

export { ForgotPassword };
